import { Config } from "../landing-config";
import { ico_picked, ico_pink } from "../map-config";


const maxFileRows = 500;
export const BTS_DARK_FIBER_CONFIG: Config = {
    data: {
        route: 'nodo-operatore-attivo-dark-fiber',
        page_title: 'Nodo Operatore Passivo - BTS Passiva | Open Fiber',
        service_title: 'Nodo Operatore Passivo - BTS Passiva',
        service_description: '',
        service_name: '',
        service_slug: 'noadarkfiber',
        errorTimeout: 0,
        feasibilityModelSingle: false,
        feasibilityEnabled: true,
        api: {
            massiveImport: {
                massiveDetailsPath: '/serviziobtsdarkfiber/massivep2p/detail',
                massiveUploadPath: '/point/serviziobtsdarkfiber/massivep2p/upload',
                massiveDownloadPath: '/serviziobtsdarkfiber/data/massive/import.xlsx',
                massiveDownloadPath_2p: '/serviziobtsdarkfiber/data/massive/import_2p.xlsx',
                massiveP2pSalesforcePath: '/serviziobtsdarkfiber/massivep2p/send-to-salesforce',
                max_file_rows: maxFileRows,
                info_message: null
            },
            p2pPath: '/point/serviziobtsdarkfiber/p2p',
			bboxPath: '/point/bts/building',
			buildingSearchParams: null
        },
        dynamic_aend_name: 'NOA_PASSIVE'
    },
    multiple_points: {
        variable: true,
        max: 2,
        points: {
            b_end: {
                default_method: 'address',
                switch_methods: true,
                address: true,
                pop: false,
                poi: true,
                pfs: false,
                roe: false,
                coordinates: true,
                id_building: false,
                id_bts_noa: true,
                id_bts_building: true,
                id_school: false,
                city_noa: true,
                city_pop: false,
                city_poi: false,
                city_building: true,
                id_healthcare: false,
                upload: true,
                popAndPoiAutocomplete: false,
                punti_intermedi: false,
                pop_pcn_xpop: false,
            },
            a_end: {
                default_method: 'address',
                switch_methods: true,
                address: true,
                pop: false,
                poi: false,
                pfs: false,
                roe: false,
                coordinates: true,
                id_building: false,
                id_bts_noa: false,
                id_bts_building: false,
                id_school: false,
                city_noa: false,
                city_pop: false,
                city_poi: false,
                city_building: false,
                id_healthcare: false,
                upload: true,
                popAndPoiAutocomplete: false,
                punti_intermedi: false,
                pop_pcn_xpop: false,
            }
        },
        initial_points: ['b_end']
    },
    map: {
        map_events: ['zoom_changed', 'bounds_changed', 'dragend', 'dblclick'],
        marker_has_label: true,
        marker_default_icon: ico_pink,
        clear_markers_zoom_level: 12
    },
    research_methods: {
        id_building: false,
        id_bts_noa: true,
        id_bts_building: true,
        id_school: false,
        id_healthcare: false,
        punti_intermedi: false,
        pop_pcn_xpop: false,
    },
    area_types: ['CoveredAGF'],
    area_types_short: null,
    kml: false,
    pop: {
        load: true,
        view_initial: false,
        click: false,
        loadCities: false
    },
    pcn: {
        load: true,
        view_initial: false,
        click: false
    },
    pop_agf: {
        load: false,
        view_initial: false,
        click: false
    },
    poi: {
        load: true,
        view_initial: false,
        click: false,
        x_pop: false,
        is_registered: false,
        custom_research_method: 'Address',
        loadCities: false
    },
    pfs: {
        load: false,
        view_initial: false,
        click: false,
        type: 'PFS'
    },
    roe: {
        load: false,
        view_initial: false,
        click: false,
        type: 'ROE'
    },
    cno: {
        load: false,
        view_initial: false,
        click: false,
        type: 'CNO'
    },
    pozzetto: {
        load: false,
        view_initial: false,
        click: false,
        type: 'POZZETTO'
    },
    building: {
        load: true,
        click: true,
        placeholder: 'Insert Building ID'
    },
    noa: {
        load: true,
        click: true,
        placeholder: 'Insert NOA ID'
    },
    bts: {
        load: true,
        types: {
            NOA: {
                load: true,
                click: true,
                placeholder: 'Insert NOA ID'
            },
            BUILDING: {
                load: true,
                click: true,
                placeholder: 'Insert Building ID'
            }
        }
    },
    punti_intermedi: {
        load: false,
        types: null
    },
    pop_pcn_xpop: {
        load: false,
        types: null
    },
    school: {
        load: false,
        click: false,
        placeholder: 'Insert School ID'
    },
    healthcare: {
        load: false,
        click: false,
        placeholder: 'Insert Healthcare ID'
    }
}